/**

Coded by www.techhighway.ca

*/

import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';


// Material Dashboard 2 React contexts
import { Typography } from "@mui/material";
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";
import { Link, useNavigate } from "react-router-dom";

const MDForbidden = forwardRef(
  ({ children,
    isNotFound,
     ...rest }, ref) => {
    const [controller] = useMaterialUIController();
    const navigate = useNavigate();

    const handleGoBack = (e) => {
        e.preventDefault();
        navigate(-1);
    }
    return (
        <MDBox
            sx={{
                height: '70vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                textAlign: 'center',
                px: 2,
            }}
        >
            {isNotFound ? (
                <WarningAmberIcon sx={{ color: 'error.main', mb: 2 }} />
            ) : (
                <LockOutlinedIcon sx={{ color: 'error.main', mb: 2 }} />
            )
            } 
            <Typography variant="h2" color="text.primary" gutterBottom>
                {isNotFound ? '404' : '403'}
            </Typography>
            <Typography variant="h5" color="text.secondary" gutterBottom>
                {isNotFound ? 'Record Not Found' : 'Forbidden Access'}
            </Typography>
            <Typography variant="body1" color="text.secondary" mb={3}>
                {isNotFound ? "We could not find the record you are trying to access."
             : "You don’t have permission to view this page."}
            </Typography>
            <MDBox display="flex" gap={2} mt={2} justifyContent="center">
                <Typography
                    variant="h6"
                    component={Link}
                    onClick={handleGoBack}
                    sx={{
                    textDecoration: 'none',
                    color: 'primary.main',
                    }}
                >
                    Go Back
                </Typography>
                <Typography
                    variant="h6"
                >
                    OR
                </Typography>
                <Typography
                    variant="h6"
                    component={Link}
                    to="/dashboard"
                    sx={{
                    textDecoration: 'none',
                    color: 'primary.main',
                    }}
                >
                    Return to Dashboard
                </Typography>
            </MDBox>
        </MDBox>
    );
  }
);

// Setting default values for the props of MDDialog
MDForbidden.defaultProps = {
  cancleButton: 'No',
  successButton: 'Yes',
  showCancelButton: true,
  showSuccessButton: true,
};

// Typechecking props for the MDDialog
MDForbidden.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "error",
    "info",
    "success",
    "warning",
  ]),
};

export default MDForbidden;